import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { navIcons } from '../utils/iconMap';
import { Mail, Search, Users, DollarSign, Phone } from 'lucide-react';

const navigation = [
  { name: 'Dashboard', href: '/', icon: navIcons.dashboard },
  { name: 'Leads', href: '/leads', icon: navIcons.leads },
  { name: 'Scraper', href: '/scraper', icon: navIcons.scraper },
  { name: 'Contact Discovery', href: '/contact-discovery', icon: Search },
  { name: 'Contact Enrichment', href: '/contact-enrichment', icon: Users },
  { name: 'Articles', href: '/articles', icon: navIcons.articles },
  { name: 'Templates', href: '/templates', icon: navIcons.templates },
  { name: 'Campaigns', href: '/campaigns', icon: navIcons.campaigns },
  { name: 'Nurture', href: '/nurture', icon: navIcons.nurture },
  { name: 'Nurture Analytics', href: '/nurture-analytics', icon: navIcons.analytics },
  { name: 'AI Drafts', href: '/ai-drafts', icon: Mail },
  { name: 'Domains', href: '/domains', icon: navIcons.domains },
  { name: 'MQLs', href: '/mqls', icon: navIcons.mqls },
  { name: 'Analytics', href: '/analytics', icon: navIcons.analytics },
  { name: 'Dialer', href: '/dialer', icon: Phone },
  { name: 'Settings', href: '/settings', icon: navIcons.settings },
];

export default function Layout() {
  const location = useLocation();
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="flex">
        {/* Sidebar - Fixed/Sticky */}
        <div className="fixed left-0 top-0 bottom-0 w-64 bg-white border-r border-gray-200 flex flex-col z-10">
          {/* Header */}
          <div className="p-4 border-b border-gray-200">
            <h1 className="text-2xl font-bold text-gray-900">LeadForge</h1>
            <p className="text-sm text-gray-500 mt-1">Lead Generation Automation</p>
          </div>
          
          {/* Navigation - Scrollable */}
          <nav className="flex-1 overflow-y-auto mt-8">
            {navigation.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`flex items-center px-4 py-3 text-sm font-medium ${
                    isActive
                      ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  <item.icon className="mr-3" size={20} />
                  {item.name}
                </Link>
              );
            })}
          </nav>
          
          {/* Footer - Fixed at bottom */}
          <div className="p-4 border-t border-gray-200 bg-white">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-900">{user?.name || user?.email}</p>
                <p className="text-xs text-gray-500">{user?.role}</p>
              </div>
              <button
                onClick={logout}
                className="text-sm text-gray-500 hover:text-gray-700"
              >
                Logout
              </button>
            </div>
          </div>
        </div>

        {/* Main content - Offset for fixed sidebar */}
        <div className="flex-1 ml-64">
          <div className="p-8">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

